import axios from "axios";
import { Base_URL } from "../url";

export const saveHSNDetails = async (hsnData, userName) => {
  try {
    const response = await axios.post(
      `${Base_URL}/HSN/HsnMaster?UserName=${userName}`,
      hsnData,
      {
        headers: { "Content-Type": "application/json" },
      }
    );
    return response.data;
  } catch (error) {
    throw error.response?.data || "Failed to save HSN";
  }
};